import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -70 });
    } else {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
};

export const submitJobSeeker = (payload) =>
    axios.post(`${API}/enquiry/job-seeker`, payload);

export const submitCompany = (payload) =>
    axios.post(`${API}/enquiry/company`, payload);

export const SITE = {
    name: "Bhoir Group of Services",
    established: "2026",
    cin: "27CNVPB5057J1ZI",
    address:
        "Kate Vrundavan Society, 5th Floor, Flat no. 501, Dapodi Guru Pimple Road, Pimpri Chinchwad",
    district: "Pune",
    state: "Maharashtra",
    pin: "411012",
    phones: ["9158499495", "9673217777"],
    emails: ["infobhoirgroups@gmail.com", "info.bhoirgroup@gmail.com"],
    logo: "/logo.jpeg",
};

export const IMAGES = {
    manufacturing:
        "https://images.unsplash.com/photo-1565954786194-d22abeaac3ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxtYW51ZmFjdHVyaW5nJTIwd29ya2VyJTIwaW5kdXN0cmlhbHxlbnwwfHx8fDE3ODU5MjQxOTJ8MA&ixlib=rb-4.1.0&q=85",
    office:
        "https://images.unsplash.com/photo-1560264280-88b68371db39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBwcm9mZXNzaW9uYWxzJTIwY29ycG9yYXRlfGVufDB8fHx8MTc4NTkyNDE5Mnww&ixlib=rb-4.1.0&q=85",
    security:
        "https://images.pexels.com/photos/27299956/pexels-photo-27299956.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    housekeeping:
        "https://images.unsplash.com/photo-1581578731548-c64695cc6952?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
    logistics:
        "https://images.unsplash.com/photo-1645736315000-6f788915923b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxsb2dpc3RpY3MlMjB3YXJlaG91c2UlMjB3b3JrZXJ8ZW58MHx8fHwxNzg1OTI0MTkyfDA&ixlib=rb-4.1.0&q=85",
    corporate:
        "https://images.unsplash.com/photo-1521791136064-7986c2920216?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBoYW5kc2hha2UlMjBoaXJpbmd8ZW58MHx8fHwxNzg1OTI0MTkyfDA&ixlib=rb-4.1.0&q=85",
};
